import { useGetDetailedMultiCurrencyBalancesQuery } from '@/api/v1';
import { useCustomer } from '@/hooks/useCustomer';
import { DetailedBalance } from '@/types/bankInfo';
import { CurrencyCodeType } from '@/types/currency';

export const useBalances = (
  ...currencies: readonly CurrencyCodeType[]
): Partial<Record<CurrencyCodeType, DetailedBalance>> => {
  const customer = useCustomer();
  const { data: balances = [] } = useGetDetailedMultiCurrencyBalancesQuery({
    beneficiaryId: customer.beneficiaryId,
    currency: currencies,
  });

  const reducer = (
    mapped: Partial<Record<CurrencyCodeType, DetailedBalance>>,
    balance: DetailedBalance,
  ): Partial<Record<CurrencyCodeType, DetailedBalance>> => {
    return { ...mapped, [balance.currencyCode]: balance };
  };

  return balances.reduce(reducer, {});
};
